import { createAndPrintLabel } from './create-and-print-label';
import { createLabel } from './create-label';

export const LocalDeliveryPrimaryActions = [createAndPrintLabel, createLabel];
